import { pxToRem } from '../../../../utils';
export default (function (siteVariables) {
  return {
    padding: "".concat(pxToRem(7), " ").concat(pxToRem(3), " ").concat(pxToRem(7), " ").concat(pxToRem(11)),
    // padding set to 1px less to account for 1px border
    iconSpace: pxToRem(12),
    borderColor: siteVariables.colors.grey[200],
    borderRadius: pxToRem(3),
    backgroundColor: siteVariables.colors.grey[100],
    backgroundColorHover: siteVariables.colors.grey[150],
    textColor: siteVariables.colors.grey[750],
    textColorHover: siteVariables.colors.grey[750],
    boxShadow: siteVariables.shadowLevel1,
    progressColor: siteVariables.colors.green[200],
    progressHeight: 4,
    headerFontSize: siteVariables.fontSizes.medium,
    headerFontWeight: siteVariables.fontWeightSemibold,
    headerLineHeight: siteVariables.lineHeightMedium,
    descriptionFontSize: siteVariables.fontSizes.small,
    descriptionFontWeight: siteVariables.fontWeightRegular,
    descriptionLineHeight: siteVariables.lineHeightDefault
  };
});